/**
 * @function v3sGraphic
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * The Graphic Element
 */
angular.module('v3sWbtPlayerApp').directive('v3sThumbnail', ["$rootScope", "v3sContentMediaPath", "$modal", "v3sMediaService","$window", function ($rootScope, v3sContentMediaPath, $modal, v3sMediaService, $window) {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/js/page/elements/v3sThumbnail.tpl.html',
        link: function (scope, element, attrs) {
            var parentElement = element.parent();
            scope.isGraphicThumbnail = parentElement[0].tagName.toLowerCase()== 'v3s-graphic';
            
            if (scope.isGraphicThumbnail) {
                scope.v3sFile = parentElement.attr('v3s-file');
            } else {
                scope.v3sVideo = parentElement;
            }
            var modal, videoModal;
            scope.thumbwidth = parseInt(element.attr("v3s-width"));

            if (element.parent()[0].tagName.toLowerCase() == "v3s-video") {
              


            } 
        }
    }
}]);
